
export default "/assets/paper-clip-micro.d4b9ec44.svg"